import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsArray, IsOptional, IsUUID } from 'class-validator'

/** IDs canoniques curriculum (Concept.id / Competency.id), résolus vers ProgramConcept côté service. */
export class PedagogyNearContentRequestDto {
  @ApiPropertyOptional({
    description: 'Identifiants canoniques des notions (curriculum Concept.id)',
    type: [String],
  })
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  conceptIds?: string[]

  @ApiPropertyOptional({
    description: 'Identifiants canoniques des compétences (curriculum Competency.id)',
    type: [String],
  })
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  competencyIds?: string[]

  @ApiPropertyOptional({
    description:
      "Limite leçons et chapitres retournés à ceux rattachés à cet enseignement (liens LessonTeaching / ChapterTeaching)",
  })
  @IsOptional()
  @IsUUID('4')
  teachingId?: string
}
